module.exports = __webpack_public_path__ + "img/icon_8.b24867af.png";